import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Navigation } from "../Navigation";
import OrgAccount from "./Account/OrgAccount";
import OrgProfile from "./OrgProfile";
import OrgUsage from "./OrgUsage";
import OrgUsers from "./OrgUsers";

export const OrgLayout = (props:any) => {
    let { path, url } = useRouteMatch();

    return (
        <div>
            <Navigation {...props}/>
            <div>
                <Switch>
                    <Route exact path={path}>
                        <Redirect to={`${url}/profile`} push={true} />
                    </Route>
                    <Route path={`${path}/profile`}>
                        <OrgProfile {...props}></OrgProfile>
                    </Route>
                    <Route path={`${path}/users`}>
                        <OrgUsers {...props}></OrgUsers>
                    </Route>
                    {/*<Route path={`${path}/account`}>
                        <OrgAccount {...props}></OrgAccount>
                    </Route>*/}
                    <Route path={`${path}/usage`}>
                        <OrgUsage {...props}></OrgUsage>
                    </Route>
                </Switch>
            </div>
        </div>
    );
}